var React = require('react');

function ExCapArrowInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#F6624E;}\n"),React.createElement("path",{"className":"st0","d":"M21.3,7.1L0,13l13,0.4L21.3,7.1z","key":1}),React.createElement("path",{"className":"st0","d":"M0.4,0l1.8,6.6l19.1,0.6l-7.9-6.7L0.4,0z","key":2})]);
}

ExCapArrowInline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 21.3 13.4","style":{"enableBackground":"new 0 0 21.3 13.4"},"xmlSpace":"preserve"};

module.exports = ExCapArrowInline;

ExCapArrowInline.default = ExCapArrowInline;
